import React, { PropsWithChildren } from 'react';
import { Column } from '../contexts/column.context';
import { squareToPixel } from '../utils/graph.utils';

export const STRIP_EDITOR_WIDTH = squareToPixel(3);

export const StripEditor: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Column width={STRIP_EDITOR_WIDTH} data-testid='strip-editor'>
      {children}
    </Column>
  );
};
